<template>
  <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="width: 700px; max-width: 90vw;">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">Add Switchboard</div>
        <q-space />
        <q-btn icon="close" flat round dense @click="$emit('update:modelValue', false)" />
      </q-card-section>

      <q-card-section>
        <q-form @submit.prevent="handleSubmit">
          <q-input
            :model-value="formData.name"
            label="Name"
            outlined
            required
            class="q-mb-md"
            @update:model-value="$emit('update:name', $event)"
          />

          <q-select
            :model-value="formData.type"
            :options="switchboardTypes"
            label="Type"
            outlined
            emit-value
            map-options
            required
            class="q-mb-md"
            @update:model-value="$emit('update:type', $event)"
          />

          <q-input
            :model-value="formData.description"
            label="Description"
            outlined
            type="textarea"
            rows="2"
            class="q-mb-md"
            @update:model-value="$emit('update:description', $event)"
          />
        </q-form>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Cancel" @click="$emit('update:modelValue', false)" />
        <q-btn
          color="primary"
          label="Add"
          :disable="!formData.name || !formData.type"
          @click="handleSubmit"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';

  const props = defineProps({
    modelValue: {
      type: Boolean,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    switchboardTypes: {
      type: Array,
      required: true,
    },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:name',
    'update:type',
    'update:description',
    'submit',
  ]);

  const handleSubmit = () => {
    emit('submit');
  };
</script>
